export const event = {
  brand: 'Unified Success',
  brandPillars: 'Marriage • Money • Mission',
  trademark: 'Built to carry more.™',
  hosts: 'Curtis & Spring Eatmon IV',
  eventLine:
    'Friday, October 16, 2026 • 7:15 PM CT • Live on Zoom • Replay Included',
  dateLabel: 'Friday, October 16, 2026',
  timeLabel: '7:15 PM CT',
  location: 'Live on Zoom',
  isoDate: '2026-10-17T00:15:00Z',
  ctaLabel: 'Check our foundation',
  backdropUrl:
    'https://cdn.magicpatterns.com/patterns/generated-images/e9a16438-5cc8-4fd3-be6c-58272df09209.jpg',
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/nZFMLPkSn6UgL8WRsGMvhA/Meet_the_3.png',
  portraitUrl:
    'https://cdn.magicpatterns.com/uploads/jWaGMCJwuLaBr6CY7N7VKd/IMG_7273_2.jpg',
}

export const hero = {
  headline: 'Can your relationship carry the weight of your success?',
  support: [
    'You worked hard to build the career, business, income, family and future. But every next level adds weight to the relationship carrying it.',
    'Nothing has to be broken for the foundation to be under pressure.',
  ],
}

export const weight = {
  headline: 'Success adds weight.',
  lines: [
    'More income creates more decisions.',
    'More business creates more responsibility.',
    'More leadership creates more demands.',
    'More children create more complexity.',
    'More opportunity creates more pressure on time.',
    'More ambition creates more competing priorities.',
  ],
  turn: 'Success isn’t the enemy. Unprepared infrastructure is.',
  close:
    'The danger is that successful couples can become exceptional at managing life together while slowly becoming less intentional about actually living it together.',
}

export const forYou = {
  headline: 'This is for the couple who has something worth protecting.',
  lines: [
    'You’re committed to each other.',
    'You’re building something significant.',
    'You already invest in your growth.',
    'Your life is getting bigger — not smaller.',
    'You’re not looking for someone to fix your spouse.',
    'You want to make sure your relationship is prepared for where you’re going next.',
  ],
  close:
    'You’re not coming because your relationship is broken. You’re coming because what you’ve built is valuable enough to protect.',
}

export const notForYou = {
  headline: 'Unified Success is not for everybody.',
  lines: [
    'This is not emergency marriage counseling.',
    'This is not a room for blaming or fixing your partner.',
    'This is not for couples uncertain whether they are committed to building a future together.',
    'This is not for people who have to be convinced that their relationship deserves intentional investment.',
  ],
  close:
    'It’s for couples preparing for what’s next — not waiting for something to go wrong.',
}

export const solution = {
  body: 'A live experience designed to help ambitious couples identify where the weight of success is creating pressure — and build the alignment necessary to carry their next level together.',
}

export const modules = [
  {
    title: 'The invisible weight of success',
    body: 'Identify where growth has added pressure to your relationship — and what you’ve normalized along the way.',
  },
  {
    title: 'Marriage: connected or coordinated?',
    body: 'Discover whether you’re building deeper connection or simply becoming more efficient at managing life together.',
  },
  {
    title: 'Money: what are we actually building for?',
    body: 'Expose differences in what money represents, what financial success means and what you’re trying to create together.',
  },
  {
    title: 'Mission: are we building the same empire?',
    body: 'Compare the future each of you sees and establish what you’re unwilling to sacrifice to achieve it.',
  },
]

export const outcome = {
  headline: 'You’ll leave with your Foundation Check.',
  scores: ['Marriage alignment', 'Money alignment', 'Mission alignment'],
  questions: [
    'Where is our greatest pressure?',
    'What could it eventually cost us?',
    'What conversation have we postponed?',
    'What decision do we need to make?',
    'What will we commit to for the next 30 days?',
  ],
  includes: [
    'Live 90-minute class',
    'Foundation Check workbook',
    'Replay included',
    'Live Q&A with Curtis & Spring',
  ],
}

export const credibility = {
  headline: 'We didn’t learn this from the sidelines. We’ve had to live it.',
  body: 'Our relationship wasn’t built in a laboratory. It was built while carrying real life. Before there was Unified Success, there were seasons of loss, trauma, single parenting, becoming a blended family, raising children together, corporate careers, executive leadership, entrepreneurship, building businesses, financial decisions, faith, leadership and eventually helping develop thousands of people across the country. We’ve experienced what happens when life gets bigger. More people need you. More decisions depend on you. More opportunities compete for your time. And the very success you’re praying for can begin placing new weight on the relationship underneath it. We don’t teach Unified Success because we’ve built a perfect marriage. We built it because we’ve had to develop the systems necessary to keep building a significant life together.',
  proof: [
    {
      label: 'Family',
      body: 'Single parenting → blended family → parenting together',
    },
    { label: 'Resilience', body: 'Loss, widowhood, trauma and rebuilding' },
    {
      label: 'Leadership',
      body: 'Corporate America → executive leadership → entrepreneurship',
    },
    { label: 'Business', body: 'Building and leading successful businesses together' },
    { label: 'Development', body: 'Training and developing thousands nationwide' },
    {
      label: 'Real life',
      body: 'Marriage • Money • Children • Business • Faith • Mission',
    },
  ],
}

export const gallery = [
  'https://cdn.magicpatterns.com/uploads/tEi8HBeQ8X4Jb3DjtCmfpE/tempImageF3ibpa.png',
  'https://cdn.magicpatterns.com/uploads/k59EYfvxrocg6XZgQQoEQW/IMG_2309.jpg',
  'https://cdn.magicpatterns.com/uploads/k89DkCndYntBC59J5VsBU8/IMG_2290.jpg',
  'https://cdn.magicpatterns.com/uploads/jGkPuGhkyNnEj1s7QBKpsV/IMG_2288_3.jpg',
  'https://cdn.magicpatterns.com/uploads/vigs1r1Dsheo5oN9ATb8Ps/IMG_2287.jpg',
  'https://cdn.magicpatterns.com/uploads/fYpvnCbqEEhdY2HFEuzqr4/IMG_2286.jpg',
  'https://cdn.magicpatterns.com/uploads/mPi7TRogHp8R7qZK2vVHi2/IMG_2268.jpg',
  'https://cdn.magicpatterns.com/uploads/6dUoXdEEur67xt9HRLiN5C/IMG_1876.jpg',
  'https://cdn.magicpatterns.com/uploads/3feHG8be4e5U5rNFdoAjyh/IMG_1871.jpg',
  'https://cdn.magicpatterns.com/uploads/2AnaWgWCL1SkVpjM95mALY/IMG_1870_2.jpg',
  'https://cdn.magicpatterns.com/uploads/x3ZQUnH8BSZmE3PsmiLXVB/Image_7-9-24_at_12.54_PM.jpg',
]

export const pathway = {
  classes: [
    { label: 'Class 1', name: 'The Foundation Check', question: 'Where are we now?' },
    { label: 'Class 2', name: 'Money Alignment', question: 'What are we building for?' },
    {
      label: 'Class 3',
      name: 'Mission Alignment',
      question: 'Where are we going together?',
    },
  ],
}

export const urgency = {
  headline: 'Don’t wait for the crack. Check the foundation.',
  intro:
    'Successful people don’t wait for something valuable to break before they inspect it.',
  lines: [
    'The next promotion adds weight.',
    'The next business adds weight.',
    'The next income level adds decisions.',
    'The next child adds responsibility.',
    'The next opportunity requires more capacity.',
  ],
  close: 'Every next level adds another floor. Every floor adds more weight.',
  final:
    'If you already know you’re building more, now is the time to make sure the relationship underneath it is BUILT TO CARRY MORE.™',
}

export const pricing = [
  {
    name: 'The Foundation Check',
    price: '$97',
    unit: 'per couple',
    description:
      'Class 1, live. Identify where success is adding pressure and leave with your alignment scores and a 30-day commitment.',
    perks: [
      'Live 90-minute class',
      'Foundation Check workbook',
      'Replay included',
      'Live Q&A',
    ],
    cta: 'Reserve our Foundation Check — $97',
    url: 'https://link.builderspro.io/payment-link/6aaca2e0f426560dbc2f0edf',
    featured: false,
  },
  {
    name: 'Complete 3-class experience',
    price: '$250',
    unit: 'per couple',
    description:
      'The full pathway: where are we now, what are we building for, and where are we going together — three conversations that end in one shared direction.',
    perks: [
      'All 3 live classes',
      'Workbook + replay for each class',
      'Live Q&A every session',
      'Marriage, Money and Mission alignment systems',
    ],
    cta: 'Build our complete plan — $250',
    url: 'https://link.builderspro.io/payment-link/6aaca19f9f7ff2c808a76436',
    featured: true,
  },
]
